export const getUniqueCode = () => {
  const query = window.location.search
  const urlParams = new URLSearchParams(query)
  const uniqueCode = urlParams.get('code')

  if (!uniqueCode) throw new Error('Unique code not found')

  return uniqueCode
}
